import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  const toggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">关于在线看电影电视剧的常见疑问解答</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggle(item.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-primary-50/50 transition-colors duration-200"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">{item.question}</h3>
                <i
                  className={`text-foreground-400 text-lg transition-transform duration-200 flex-shrink-0 w-4 h-4 flex items-center justify-center ${
                    openId === item.id ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              {openId === item.id && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}